import json from '../../json'

// initial state
const state = {
  status: '',
  historys: [],
  error: ''
}

// getters
const getters = {
  error: state => state.error,
  historys: state => state.historys,
  status: state => state.status
}

const adjustDelayCertificateJson = (certJson, timeZones) => {
  for (let a = 0; a < certJson.delay_certificates.length; a++) {
    const cert = certJson.delay_certificates[a]
    const orgCerts = cert.data
    const dateCerts = []
    timeZones.forEach(timeZone => {
      const timeZoneCert = {
        time_zone_id: timeZone.time_zone_id,
        time_zone_display_name: timeZone.display_name,
        delay_certificate_item_type: 'OTHERS',
        delay_certificate: '',
        is_modified: false
      }
      const foundArea = orgCerts.filter(a => a.time_zone_id === timeZone.time_zone_id)
      if (foundArea.length > 0) {
        const certJson = foundArea[0]
        timeZoneCert.time_zone_display_name = timeZone.display_name
        timeZoneCert.delay_certificate_item_type = certJson.delay_certificate_item_type
        timeZoneCert.delay_certificate = certJson.delay_certificate
        timeZoneCert.is_modified = certJson.is_modified
      }

      dateCerts.push(timeZoneCert)
    })
    certJson.delay_certificates[a].data = dateCerts
  }
  certJson.delay_certificates = certJson.delay_certificates.sort((a, b) => a.date > b.date ? -1 : (a.date < b.date ? 1 : 0))
  return certJson
}

// actions
const actions = {
  all ({ commit, state }, [lineId, timeZones]) {
    commit('initHistory')
    json.get('/history/ope/delay_certificate/' + lineId + '.json', undefined, true)
      .then(response => {
        const certs = adjustDelayCertificateJson(response.data, timeZones)
        commit('setHistory', certs)
        commit('setStatus', 'init')
      })
      .catch(() => {
        // 過去履歴の遅延証明書項目が空白となったページが表示
        commit('setHistory', { 'delay_certificates': [] })
        commit('setStatus', 'init')
      })
  }
}

// mutations
const mutations = {
  setStatus (state, data) {
    state.status = data
  },
  setHistory (state, data) {
    state.historys = data.delay_certificates
  },
  initHistory (state) {
    state.historys = []
    state.status = ''
  },
  setError (state, response) {
    if (response && response.data && response.data.error) {
      state.error = response.data.error
    } else {
      state.error = 'サーバーに接続できません。'
    }
    state.historys = []
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/history.js